import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=74165d6f&scoped=true&"
import script from "./inputs.vue?vue&type=script&lang=js&"
export * from "./inputs.vue?vue&type=script&lang=js&"
import style0 from "./inputs.vue?vue&type=style&index=0&id=74165d6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74165d6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74165d6f')) {
      api.createRecord('74165d6f', component.options)
    } else {
      api.reload('74165d6f', component.options)
    }
    module.hot.accept("./inputs.vue?vue&type=template&id=74165d6f&scoped=true&", function () {
      api.rerender('74165d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/inputs.vue"
export default component.exports